import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Shield, Phone, Check } from "lucide-react";
import { OutsideAssist } from "@/components/OutsideAssist";

// Nearest PSP barracks for any Pennsylvania call — shown even when a local PD covers the address.
export const NearestBarracks = ({ incident, compact = false }) => {
  const [d, setD] = useState(null);
  const lat = incident?.location?.lat, lng = incident?.location?.lng;
  useEffect(() => {
    if (lat == null || lng == null) { setD(null); return; }
    client.get("/ali/nearest-psp", { params: { lat, lng } }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [lat, lng]);
  if (!d?.in_pa || !d.station) return null;
  const s = d.station;
  if (compact) {
    return (
      <div data-testid="mdt-nearest-barracks" className="mt-1.5 flex flex-wrap items-center gap-2 font-mono text-[11px]">
        <span className="flex items-center gap-1 text-[#9CA3AF]"><Shield size={12} /> PSP {s.name} · <span className="text-[#FCD34D]">{s.distance_mi} mi</span></span>
        {s.phone && <a data-testid="mdt-barracks-call" href={`tel:${s.phone.replace(/[^\d+]/g, "")}`} className="flex items-center gap-1.5 px-3 py-1.5 rounded font-head font-bold text-xs bg-[#374151] text-white border border-[#6B7280] active:bg-[#4B5563]"><Phone size={12} /> CALL PSP {s.phone}</a>}
        <OutsideAssist incident={incident} agency={`Pennsylvania State Police — ${s.name}`} phone={s.phone} compact />
      </div>
    );
  }
  return (
    <div data-testid="nearest-barracks" className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-0.5 px-2 py-1.5 border border-[#6B7280]/60 bg-[#1F2937]/60 font-mono text-[10px] text-[#E5E7EB]">
      <Shield size={12} className="text-[#D1D5DB] shrink-0" />
      <span className="uppercase text-[#9CA3AF]">Nearest PSP barracks</span>
      <span className="font-bold text-white">{s.name}</span>
      <span className="text-[#FCD34D]">{s.distance_mi} mi</span>
      {s.phone && <a data-testid="nearest-barracks-phone" href={`tel:${s.phone.replace(/[^\d+]/g, "")}`} className="flex items-center gap-1 text-[#93C5FD] underline"><Phone size={10} /> {s.phone}</a>}
      <span className="text-[#6B7280] truncate">{s.address}</span>
      {d.kind !== "psp" && <span className="text-[#6B7280]">· local: {d.local_agency}</span>}
      {incident?.psp_assist && !incident?.outside_assist && <span data-testid="psp-assist-line" className="w-full flex items-center gap-1 text-[#BBF7D0] font-bold"><Check size={11} /> PSP ASSIST REQUESTED by {incident.psp_assist.unit} at {(incident.psp_assist.ts || "").slice(11, 16)}Z{incident.psp_assist.station ? ` · ${incident.psp_assist.station}` : ""}</span>}
      <span className="w-full"><OutsideAssist incident={incident} agency={`Pennsylvania State Police — ${s.name}`} phone={s.phone} /></span>
    </div>
  );
};
